
export default {
  props: ["imageName", "altText"],
  data: function () {
    return {};
  },
};
